import { useParams } from "react-router";
import { TopBar } from "../components/TopBar";
import { ConditionPill } from "../components/shared/ConditionPill";
import { Tile } from "../components/shared/Tile";
import { sessionsHref } from "../lib/links";
import { moodForEffortOrCost, moodForSuccess } from "../lib/moods";
import { computeStats, topConditions } from "../lib/stats";
import { useManifestStore } from "../state/manifestStore";
import { useSettings } from "../state/settingsStore";

export function Overview() {
  const { tenant } = useParams();
  const manifest = useManifestStore((s) => s.manifest);
  if (!manifest || !tenant) return null;

  const tenantInfo = manifest.tenants.find((t) => t.id === tenant);
  const syntheticOnly = useSettings((s) => s.syntheticOnly);
  const allTenantSessions = manifest.sessions.filter((s) => s.tenant === tenant);
  const sessions = syntheticOnly ? allTenantSessions.filter((s) => s.synthetic) : allTenantSessions;
  const projects = manifest.projects.filter((p) => p.tenant === tenant);
  const stats = computeStats(sessions);

  return (
    <>
      <TopBar tenant={tenant} title={`${tenantInfo?.name ?? tenant} — Overview`} />
      <div className="app-content">
        <section>
          <h3 className="section-h">Vitals · last period</h3>
          <div className="vitals">
            <Tile label="Sessions" value={String(stats.sessions)} />
            <Tile
              label="Success rate"
              value={`${stats.meanSuccess}%`}
              mood={moodForSuccess(stats.meanSuccess)}
            />
            <Tile
              label="Human effort"
              value={`${stats.meanEffort}`}
              mood={moodForEffortOrCost(stats.meanEffort)}
            />
            <Tile
              label="AI cost"
              value={`${stats.meanCost}`}
              mood={moodForEffortOrCost(stats.meanCost)}
            />
          </div>
        </section>

        <section>
          <h3 className="section-h">Projects</h3>
          <div className="project-grid">
            {projects.map((p) => {
              const pSessions = sessions.filter((s) => s.project === p.id);
              const conds = topConditions(pSessions, 3);
              return (
                <article key={p.id} className="project-card">
                  <header>
                    <strong>{p.name}</strong>
                    <span className={`badge flavor-${p.flavor}`}>{p.flavor.replace("_", " ")}</span>
                  </header>
                  <p className="meta-label">
                    {p.function} · {p.vendor || "—"}
                  </p>
                  <p className="meta-label mono">{pSessions.length} sessions</p>
                  <div className="condition-pills">
                    {conds.map((c) => (
                      <ConditionPill
                        key={c.code}
                        code={c.code}
                        to={sessionsHref(tenant, { project: p.id, issue: c.code })}
                        count={c.count}
                      />
                    ))}
                  </div>
                </article>
              );
            })}
          </div>
        </section>
      </div>
    </>
  );
}
